export const role = {
  userintervention: "User Intervention",
  userasset: "User Asset",
  userlocation: "User Location",
  userorganization: "User Organization",
  adminlocation: "Admin Location",
  adminorganization: "Admin Organization",
  superadmin: "Super Admin",
};
